// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.textarea[data-v-8c8d9e9a] {\n  position: relative;\n}\n.textarea[data-v-8c8d9e9a]:before {\n  position: absolute;\n  content: \"\";\n  display: block;\n  width: 98%;\n  height: 30px;\n  background: #fff;\n  z-index: 1;\n  top: 0.2rem;\n  left: 0.3rem;\n}\n", ""]);
// Exports
module.exports = exports;
